// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1Cyh8","title":"Images90_title__1KG5Z","images":"Images90_images__1Rb_P"};